import * as patterns from '@Forms/validation/fields/patterns';

import type { CountryCode } from '@Types/Base';

interface Params {
  country: CountryCode;
  lang: string;
}

const errorMessages = {
  ru: {
    longCode: 'Код подтверждения должен иметь 4 цифры',
    wrongCode: 'Код подтверждения указан неверно',
    requiredNumber: 'Укажите номер телефона',
    wrongNumber: 'Номер телефона указан неверно',
  },
  uz: {
    longCode: "Tasdiqlash kodida 4 ta raqam bo'lishi kerak",
    wrongCode: "Tasdiqlash kodi noto'g'ri ko'rsatilgan",
    requiredNumber: "Telefon raqamini ko'rsating",
    wrongNumber: "Telefon raqami noto'g'ri ko'rsatilgan",
  },
};

export default ({ country, lang }: Params) => {
  return {
    title: 'login',
    $schema: 'http://json-schema.org/draft-07/schema',
    type: 'object',
    properties: {
      phone: {
        description: 'Телефон',
        type: 'string',
        errorMessage: {
          minLength: errorMessages[lang].requiredNumber,
          required: errorMessages[lang].requiredNumber,
          pattern: errorMessages[lang].wrongNumber,
        },
      },
      code: {
        description: 'Код подтверждения',
        type: 'string',
        maxLength: 4,
      },
      resendCode: {
        description: '',
      },
      pointOfContact: {
        type: 'string',
      },
      token: {
        type: 'string',
        errorMessage: {
          required: 'Не указан токен авторизации',
        },
      },
      type: {
        type: 'string',
        enum: ['sms', 'yandexId'],
        errorMessage: {
          required: 'Не указан тип авторизации',
          enum: 'Неверный тип авторизации',
        },
      },
    },
    allOf: [
      {
        if: {
          properties: {
            resendCode: {
              const: 'false',
            },
            type: {
              enum: ['sms'],
            },
          },
        },
        then: {
          properties: {
            code: {
              type: 'string',
              pattern: '^[0-9]{4}$',
              errorMessage: {
                maxLength: errorMessages[lang].longCode,
                pattern: errorMessages[lang].wrongCode,
              },
            },
          },
        },
      },
      // Если это авторизация через SMS, то обязателен номер
      {
        if: {
          properties: {
            type: {
              enum: ['sms'],
            },
          },
        },
        then: {
          properties: {
            phone: {
              pattern: patterns.phone({ country }),
              minLength: 18,
            },
          },
          required: ['phone'],
        },
      },

      // Если это авторизация через Яндекс.ID, то обязателен токен
      {
        if: {
          properties: {
            type: {
              enum: ['yandexId'],
            },
          },
        },
        then: {
          required: ['token'],
        },
      },
    ],
  };
};
